import type { FC } from 'react';
import GreyBorderedBox from '../components/grey-bordered-box';
import BulletList from '../components/bullet-list';
import AttentionBox from '../components/attention-box';
import NoticeSection from '../components/notice-section';
import styles from '../styles/console-booking-notice.module.scss';

const ConsoleBookingNotice: FC<{
    available: boolean;
    messages: string[];
    onNewBooking: () => void;
    onSearchBooking: () => void;
}> = ({ available, messages, onNewBooking, onSearchBooking }) => {
    return (
        <div className={styles.consoleBookingNotice}>
            {available && (
                <div className={styles.navigateContainer}>
                    <NavigateButton title="新規予約" onClick={onNewBooking} />
                    <NavigateButton title="予約確認・変更・キャンセル" onClick={onSearchBooking} />
                </div>
            )}
            <AttentionBox title="お客さまへのお知らせ" messages={messages} />
            <GreyBorderedBox className={styles.description}>
                <NoticeSection title="■ご予約にあたって">
                    <BulletList>
                        {/* <li>
                            コールセンター経由の予約はお客様の携帯電話にSMSにて予約案内を行います。
                        </li>
                        <p></p> */}
                        <li>
                            対象機種でディスプレイ割れの場合のみ、店頭即時修理の予約が可能です。
                        </li>
                        <li>
                            以下の場合は、修理サービスをご提供できない場合がありますのでご了承ください。
                            <BulletList>
                                <li>修理前の事前診断ができない場合</li>
                                <li>ディスプレイ以外に破損がある場合</li>
                                <li>修理部品の在庫がない場合 など</li>
                            </BulletList>
                        </li>
                    </BulletList>
                </NoticeSection>
                <NoticeSection title="■ご予約時の注意事項">
                    <BulletList>
                        <li>
                            正常にお申し込みが完了できなくなる恐れがありますので、お申し込み手続き中ブラウザや携帯電話の
                            「戻る」ボタンは押さないようにお願いします。
                        </li>
                        <li>
                            なお、「戻る」ボタンを押して手続きが続けられない状態になった場合は、お手数ですが一度ブラウザを終了してから再度手続きを行なってください。
                        </li>
                    </BulletList>
                </NoticeSection>
                <NoticeSection title="■推奨環境（ブラウザ）">
                    <BulletList>
                        <li>
                            最新のブラウザにアップデートしてご利用ください。古いバージョンや特定の設定では、正しく表示されないことがあります。
                        </li>
                        <li>正常に表示されない場合、別のブラウザでのご利用をお試しください。</li>
                    </BulletList>
                </NoticeSection>
            </GreyBorderedBox>
        </div>
    );
};

const NavigateButton: FC<{
    title: string;
    onClick: () => void;
}> = ({ title, onClick }) => {
    return (
        <button className={styles.navigateButton} type="button" onClick={onClick}>
            <span className={styles.navigateTitle}>{title}</span>
        </button>
    );
};

export default ConsoleBookingNotice;
